/**
 * 助手形象「小星」的 SVG 版（与 iOS StarMascot 的待机状态一致）：圆角五角星 + 眼睛 + 腮红 + 微笑，
 * 待机时上下浮动、每 4.2 秒眨一次眼（CSS 动画，见 components.css）。
 */

function starPoints(cx: number, cy: number, outer: number, inner: number): string {
  const pts: string[] = [];
  for (let i = 0; i < 10; i++) {
    const r = i % 2 === 0 ? outer : inner;
    const a = -Math.PI / 2 + (i * Math.PI) / 5;
    pts.push(`${(cx + r * Math.cos(a)).toFixed(2)},${(cy + r * Math.sin(a)).toFixed(2)}`);
  }
  return pts.join(" ");
}

const S = 100;
const C0 = (S * 1.35) / 2;
const STAR = starPoints(C0, C0, S * 0.5, S * 0.29);

export function StarMascot({ size = 64, animated = true }: { size?: number; animated?: boolean }) {
  const face = { x: C0, y: C0 + S * 0.04 };
  const eyeW = S * 0.075;
  const eyeH = S * 0.105;
  const mouthY = face.y + S * 0.07;
  const mw = S * 0.11;
  return (
    <svg
      className={`kp-mascot ${animated ? "is-animated" : ""}`}
      width={size * 1.35}
      height={size * 1.35}
      viewBox={`0 0 ${S * 1.35} ${S * 1.35}`}
      aria-hidden
    >
      <g className="kp-mascot-body">
        {/* 先描深色粗边，再填充并用同色描边让尖角变圆 */}
        <polygon points={STAR} fill="#FFB627" stroke="#C98A0B" strokeWidth={S * 0.13} strokeLinejoin="round" />
        <polygon points={STAR} fill="#FFB627" stroke="#FFB627" strokeWidth={S * 0.08} strokeLinejoin="round" />
        <g className="kp-mascot-eyes">
          {[-S * 0.12, S * 0.12].map((dx) => (
            <g key={dx}>
              <ellipse cx={face.x + dx} cy={face.y - S * 0.07} rx={eyeW / 2} ry={eyeH / 2} fill="#1E2430" />
              <circle cx={face.x + dx + S * 0.007} cy={face.y - S * 0.07 - eyeH / 2 + S * 0.022} r={S * 0.0125} fill="rgba(255,255,255,0.9)" />
            </g>
          ))}
        </g>
        {[-S * 0.21, S * 0.21].map((dx) => (
          <circle key={dx} cx={face.x + dx} cy={face.y + S * 0.03} r={S * 0.05} fill="rgba(255,143,163,0.4)" />
        ))}
        <path
          d={`M ${face.x - mw / 2} ${mouthY - S * 0.01} Q ${face.x} ${mouthY + S * 0.045} ${face.x + mw / 2} ${mouthY - S * 0.01}`}
          fill="none"
          stroke="#1E2430"
          strokeWidth={S * 0.03}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}
